import React from 'react';
import { VideoRingSettingsPanel } from '@/components/calls/VideoRingSettingsPanel';

const VideoRingSettings = () => {
  return (
    <div className="container mx-auto py-6 max-w-4xl">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Video Call Ring Settings</h1>
        <p className="text-muted-foreground mt-2">
          Configure the escalation system for immediate video calls
        </p>
      </div>
      <VideoRingSettingsPanel />
    </div>
  );
};

export default VideoRingSettings;
